// src/api.js
const BASE_URL = 'https://api.hermespartnercapital.co';

// ─── RESEARCH ────────────────────────────────────────────────────────────────
export const researchCompany = async (businessName, city, state, tradeType, businessQuestionData) => {
  try {
    const response = await fetch(`${BASE_URL}/api/research`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ businessName, city, state, tradeType, businessQuestion: businessQuestionData })
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    if (!data.success) throw new Error(data.error || 'Research failed');

    const r = data.research;
    return {
      businessType: r.businessType || 'N/A',
      services: r.services || ['Services not available'],
      website: r.website || 'N/A',
      painPoints: r.painPoints || ['No analysis available'],
      currentPhoneSetup: r.currentPhoneSetup || 'N/A',
      opportunities: r.opportunities || ['No opportunities identified'],
      reviewInsights: r.googleReviews
        ? `${r.googleReviews.count} reviews, ${r.googleReviews.rating}⭐`
        : 'No review data',
      location: r.location,
      additionalNotes: r.additionalNotes,
    };
  } catch (error) {
    console.error('❌ Research error:', error);
    return {
      businessType: 'Error — trade type required',
      services: ['Please select trade type'],
      website: 'N/A',
      painPoints: ['Trade type selection required'],
      currentPhoneSetup: 'Unable to determine',
      opportunities: ['Select trade type for analysis'],
      error: error.message
    };
  }
};

// ─── UPDATE VAPI ASSISTANT ───────────────────────────────────────────────────
export const updateVapiAssistant = async (businessInfo, researchData, emergencyHandling, phoneChallenge) => {
  try {
    const response = await fetch(`${BASE_URL}/api/update-vapi-assistant`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ businessInfo, researchData, emergencyHandling, phoneChallenge })
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${response.status}`);
    }

    const data = await response.json();
    if (!data.success) throw new Error(data.error || 'Vapi integration failed');
    return data;

  } catch (error) {
    console.error('❌ Vapi error:', error);
    throw new Error(`Failed to create live assistant: ${error.message}`);
  }
};

// ─── SEND STRIPE PAYMENT LINK ────────────────────────────────────────────────
export const sendStripePaymentLink = async (prospectInfo, businessInfo) => {
  try {
    const response = await fetch(`${BASE_URL}/api/send-payment-link`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prospectInfo, businessInfo })
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${response.status}`);
    }
    const data = await response.json();
    if (!data.success) throw new Error(data.error || 'Payment link failed');
    return data;
  } catch (error) {
    console.error('❌ Stripe error:', error);
    throw new Error(`Failed to send payment link: ${error.message}`);
  }
};

// ─── SEND CONTRACT ───────────────────────────────────────────────────────────
export const sendContract = async (prospectInfo, businessInfo, researchData, rep = 'Randy') => {
  try {
    const response = await fetch(`${BASE_URL}/api/send-contract`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
     body: JSON.stringify({ prospectInfo, businessInfo, researchData, rep })
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${response.status}`);
    }

    const data = await response.json();
    if (!data.success) throw new Error(data.error || 'Contract sending failed');
    return data;

  } catch (error) {
    console.error('❌ Contract error:', error);
    throw new Error(`Failed to send contract: ${error.message}`);
  }
};